/**
 * The creator's fixed look and VIP plans for the real build.
 *
 * src/config/creator.json is generated by `npm run sync` from
 * config.master.json (appearance → look, sales.promos → plans). The look uses
 * the same shape as the demo customizer, so what the creator picked with the
 * 🎨 brush in the demo renders identically here. The demo build ignores it.
 */
import creator from '@/config/creator.json'
import type { DemoCustomization } from './customizer'
import { IS_DEMO } from './demo'

export interface HeroStat {
  v: number
  label: string
  pref?: string
  suf?: string
}

interface CreatorFile {
  look?: DemoCustomization
  plans?: { months: number; discount: number }[]
  stats?: HeroStat[]
}

const file = creator as CreatorFile

export const CREATOR_LOOK: DemoCustomization = IS_DEMO ? {} : file.look ?? {}
export const CREATOR_PLANS = IS_DEMO ? undefined : file.plans

const DEMO_STATS: HeroStat[] = [
  { v: 50, label: 'canal vip', pref: '+', suf: ' videos' },
  { v: 1, label: 'video semanal', pref: '+' },
  { v: 20, label: 'colabs', pref: '+' },
]

/** The three numbers under the hero (config.master.json → profile.stats, exactly three). */
export const HERO_STATS: HeroStat[] = !IS_DEMO && file.stats?.length === 3 ? file.stats : DEMO_STATS
